module.exports = __webpack_public_path__ + "static/media/scan_qr.5423354c.png";